import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        margin: `${theme.spacing()}px 0`,
        '& svg': {
            margin: `0 ${theme.spacing()}px 0 0`,
            verticalAlign: 'middle',
        },
    },
});

const IconLabel = ({ icon, label, classes, className }) => (
    <Typography
        color="textSecondary"
        variant="body2"
        className={classNames(classes.root, className)}
    >
        {icon}
        {label}
    </Typography>
);

IconLabel.propTypes = {
    classes: PropTypes.object.isRequired,
    icon: PropTypes.node.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default withStyles(styles)(IconLabel);
